<template>
<!-- <div class="text-container">
  <div class="agreement-titile">“爱开”隐私协议</div>
  <p></p>

  <p></p>

  <p>杭州邮鸽网络科技有限公司及其关联方（简称“我们”）作为爱开的运营者，非常重视用户隐私的保护，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们制定本“隐私政策”并特别提示：希望您在使用爱开及相关服务前仔细阅读并理解本隐私政策，以便做出适当的选择。</p>

  <p>本隐私政策将帮助您了解：</p>

  <p>1.我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。</p>

  <p>2.当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。</p>

  <p>3.精确地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。</p>

  <p>4.本隐私政策适用于您通过爱开应用程序、爱开官方网站访问和使用我们的产品和服务。</p>

  <p>下文将帮您详细了解我们如何收集、使用、存储、传输、共享、转让（如适用）与保护个人信息。</p>

  <p></p>

  <div class="content-titile">一、我们如何收集和使用个人信息。</div>

  <p>我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息：</p>

  <p>1.注册、登录、认证</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1注册、登录帐号</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1.1当您注册、登录爱开及相关服务时，您可以通过手机号创建帐号，并且完善相关的身份信息，收集这些信息是为了帮助您完成注册。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.2认证</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.2.1在您使用资格认证的功能或相关服务所需时，根据相关法律法规，您可能需要提供您的真实身份信息以及驾驶证信息以完成实名验证。&nbsp;这些信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务。&nbsp;我们会基于你您注册时选择的地区对应的城市向您展示、推荐您所在地区的本地相关信息。</p>

  <p>2、上传与互动</p>

  <p>2.1&nbsp;内容上传</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.1.1用户上传内容将由爱开运营审核，审核通过的文章内容由爱开运营整理编辑后发布至爱开APP并标注原创作者昵称；审核不通过的文章则不被允许展示在爱开。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.1.2您上传文案、图片、音视频等内容或进行评论时，我们将收集您发布的信息，并展示您的昵称、上传内容和信息。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.1.3您使用上传文案、图片、音视频功能时，我们会请求您授权相机、照片、麦克风权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用爱开的其他功能。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.1.4用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中可能含有您的部分信息（如：在评论、留言、发布图文、音视频中涉及到与您相关的信息）。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.1.5我们非常重视用户的使用体验，为了丰富发布功能和优化体验，当您发布音视频时，在点击“发布”确认上传之前，可以选择保存到草稿，下次上传时可以基于草稿进行编辑。如果您取消或因其他原因未成功上传，我们会立即删除相关文案、图片及音视频。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.2&nbsp;互动交流</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.2.1当您关注帐号、进行浏览、评论、关注（收藏）、喜欢（点赞）或分享时，我们会收集您关注的帐号和前述信息，并展示关注帐号发布内容。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.2.2您可以在爱开中添加或删除好友，为帮您实现这一功能，我们会创建好友列表信息。好友列表是建立与管理好友关系所必需的必要信息。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.2.3当您使用群功能时，我们会创建群聊列表及相关信息。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.2.4当您选择使用扫码招入新司机时时，爱开可能会向您请求摄像头权限，摄像头权限是敏感权限，拒绝提供仅会使您无法通过扫码途径招入新司机，不影响其他功能的使用。</p>

  <p>3、消息通知</p>

  <p>您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式，我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等用途。</p>

  <p>4、安全运行</p>

  <p>4.1&nbsp;安全保障功能</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.1.1我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为实现安全保障功能所收集的信息是必要信息。</p>

  <p>4.2&nbsp;设备信息与日志信息</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.2.1为了保障软件与服务的安全运行，我们会收集您的硬件型号、操作系统版本号网络设备硬件地址、IP&nbsp;地址、WLAN接入点、蓝牙、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.2.2为了预防恶意程序及安全运营所必需，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.2.3我们可能使用您的账户信息、设备信息、服务日志信息以及我们关联方、合作方在获得您授权或依法可以共享的信息，用于判断账户安全、进行身份验证、检测及防范安全事件。</p>

  <p>4.3&nbsp;收集、使用个人信息目的变更</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.3.1请您了解，随着我们业务的发展，可能会对爱开的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。</p>

  <p>4.4&nbsp;依法豁免征得同意收集和使用的个人信息</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.1与国家安全、国防安全直接相关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.2与公共安全、公共卫生、重大公共利益直接相关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.3与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.4出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.5所收集的您的个人信息是您自行向社会公众公开的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.6从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.7根据您的要求签订或履行合同所必需的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.8用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.9为合法的新闻报道所必需的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.10学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.4.11法律法规规定的其他情形。</p>

  <p>特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。</p>

  <p></p>

  <div class="content-titile">二、我们如何使用Cookie等同类技术</div>

  <p>Cookie&nbsp;和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用爱开及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie&nbsp;或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie&nbsp;用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie&nbsp;和同类技术主要为了实现以下功能或服务：</p>

  <p>1.保障产品与服务的安全、高效运转我们可能会设置认证与保障安全性的Cookie&nbsp;或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>

  <p>2.Cookie的清除</p>

  <p>大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。</p>

  <p></p>

  <div class="content-titile">三、我们如何共享、转让、公开披露个人信息</div>

  <p>1.共享</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1共享原则</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1.1授权同意原则：&nbsp;未经您的同意，我们不会共享您的个人信息，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1.2合法正当与最小必要原则：&nbsp;共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1.3安全审慎原则：&nbsp;我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.2实现广告相关的共享信息</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.2.1广告推送：我们可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们不会共享用于识别您个人身份的信息（姓名、身份证号），仅会向这些合作伙伴提供不能识别您个人身份的间接画像标签及去标识化的设备信息或匿名化后的信息，以帮助其在不识别您个人身份的前提下提升广告有效触达率。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.2.2广告统计：我们可能与业务的服务商、供应商和其他合作伙伴共享分析去标识化的设备信息或统计信息，这些信息难以或无法与您的真实身份相关联。这些信息将帮助我们分析、衡量广告和相关服务的有效性。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.3实现安全与分析统计的共享信息</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.3.1保障使用安全：我们非常重视帐号、服务及内容安全，为保障您和其他用户的帐号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和关联方或服务提供商可能会共享必要的设备、帐号及日志信息。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.3.2分析产品使用情况：为分析我们服务的使用情况，提升用户使用的体验，可能会与关联方或第三方共享产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个人身份。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.3.3帮助您参加营销推广活动</p>

  <p>当您选择参加我们及我们的关联方或第三方举办的有关营销活动时，可能需要您提供姓名、通信地址、联系方式、银行帐号信息。这些信息是个人敏感信息，拒绝提供可能会影响您参加相关活动，但不会影响其他功能。只有经过您的同意，我们才会将这些信息与关联方或第三方共享，以保障您在联合活动中获得体验一致的服务，或委托第三方及时向您兑现奖励。</p>

  <p>2.转让</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.1我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;2.2随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。</p>

  <p>3.公开展示</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;3.1我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;3.2对违规帐号、欺诈行为进行处罚公告时，我们会披露相关帐号的信息。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;3.3您公开发布的作品、动态、喜欢（点赞）将会在个人主页中展示。</p>

  <p>4.依法豁免征得同意共享、转让、公开披露的个人信息</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;（1）与国家安全、国防安全直接相关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;（5）您自行向社会公众公开的个人信息；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

  <p></p>

  <div class="content-titile">四、我们如何存储个人信息</div>

  <p>1.存储地点</p>

  <p>我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。</p>

  <p>2.存储期限</p>

  <p>我们仅在为提供爱开及服务之目的所必需的期间内保留您的个人信息：您发布的信息、喜欢（点赞）及相关信息，在您未撤回、删除或未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>

  <p></p>

  <div class="content-titile">五、我们如何保护个人信息的安全</div>

  <p>1.我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</p>

  <p>2.请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。</p>

  <p>3.您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。</p>

  <p>4.您一旦离开爱开及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在爱开及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于爱开的链接或引导。</p>

  <p>5.用户终端数据的使用说明</p>

  <p>&nbsp;&nbsp;&nbsp;5.1国际移动设备识别码IMEI：识别手机序列号用以终端服务中，结合用户登入账户判定多开、多设备等可能存在作弊的行为，同时对非常用设备进行验证保证账户安全。&nbsp;&nbsp;&nbsp;&nbsp;</p>

  <p>&nbsp;&nbsp;&nbsp;5.2软件安装列表：通过获取用户软件安装列表检索运力服务导航所需要的第三方软件，通过调起第三方软件实现地理位置导航。&nbsp;&nbsp;&nbsp;&nbsp;</p>

  <p>&nbsp;&nbsp;&nbsp;5.3位置信息：针对出行运力服务中的服务者与消费者实现双方所在地定位，显示所在位置信息便捷司机服务。&nbsp;&nbsp;&nbsp;&nbsp;</p>

  <p>&nbsp;&nbsp;&nbsp;5.4MAC地址：在后台状态下获取了用户的“MAC”信息，用以平台服务中结合用户登入账户判定多开、多设备等可能存在作弊的行为，同时对非常用设备进行验证保证账户安全。</p>

  <p></p>

  <div class="content-titile">六、管理您的个人信息</div>

  <p>我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的查询、访问、修改、删除、撤回同意授权、注销帐号、投诉举报以及设置隐私功能的相关权利，以使您有能力保障您的隐私和信息安全。</p>

  <p>1.改变或撤回敏感权限设置</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.1&nbsp;您可以在设备本身操作系统中关闭GPS地理位置、通讯录、摄像头、麦克风、相册权限改变同意范围或撤回您的授权。撤回授权后我们将不再收集与这些权限相关信息。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;1.2&nbsp;改变或撤回授权的信息处理</p>

  <p>特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。</p>

  <p>2.更正您的个人信息</p>

  <p>出于安全性和身份识别的考虑，您可能无法自主修改注册时提交的某些初始注册信息（如实名认证后信息及审核通过后的内容发布账号昵称）。</p>

  <p>3.停止运营向您告知</p>

  <p>如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</p>

  <p>4.信息主体注销账户</p>

  <p>您可以通过拨致电028-62794001，进行账号注销申请。在您注销账号时，我们将停止使用并删除上述信息，并且48小时内账号注销完毕。您随时可注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的信息，法律法规另有规定的除外。</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.1.如果您需要注销账号，需同时满足以下条件：</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1)账号最近1个月内无异常登录、密码修改、密码手机或密保邮箱修改等其他影响账户安全的情形；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2)账号内无未完成的交易、订单、服务等；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3)账号没有涉及任何的投诉举报或被投诉举报；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4)账号中无尚未使用的权益，如果您还有尚未使用的权益，注销申请将视为您主动放弃相应权益；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5)不存在任何拖欠或者未缴纳的款项；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6)账号下的所有您有权的数据、信息等均已迁出及妥善备份，或您完全放弃保留、找回该等数据的权利；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7)账号注销并未涉及任何已发生的投诉、纠纷、诉讼，主管部门的调查等，以及不存在上述涉诉、被调整的现实性风险；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8)账号不存在其他依照法律法规的要求应当履行而尚未履行的义务等情形；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;4.2.我们在核查过程中，如果发现您账号不能同时满足上述条件的，您的账号注销申请将被驳回。如果您希望继续注销，需根据驳回原因处理完成相关事项后，重新发起账号注销申请。</p>

  <p>5.响应您的上述请求</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在十工作日内做出答复。如您不满意，还可以通过以下途径投诉：拨打电话028-62794001。</p>

  <p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>

  <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;5.1&nbsp;与国家安全、国防安全有关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;5.2&nbsp;与公共安全、公共卫生、重大公共利益有关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;5.3&nbsp;与犯罪侦查、起诉和审判等有关的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;5.4&nbsp;有充分证据表明您存在主观恶意或滥用权利的；</p>

  <p>&nbsp;&nbsp;&nbsp;&nbsp;5.5&nbsp;响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>

  <p></p>

  <div class="content-titile">七、隐私政策的修订和通知</div>

  <p>1.为了给您提供更好的服务，爱开及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。</p>

  <p>2.本隐私政策更新后，我们会在爱开发出更新版本，并在更新后的条款生效前通过适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。</p>

  <p></p>

  <div class="content-titile">八、联系我们</div>

  <p>如果您对个人信息保护问题有投诉、建议、疑问，您可以将问题发送至“爱开公众号”或致电400-021-6188。</p>

  <p>我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内回复。</p>

  <p></p>

  <p>本协议更新生效时间：2021年11月4日</p>
</div> -->
<div class="text-container">
  <div class="agreement-titile">“爱开”隐私协议</div>
  <p>
    邮鸽网络有限公司及其全球的关联公司（下文简称“邮鸽”、“我们”和“我们的”）深知隐私对您的重要性，并会尊重您的隐私以及保障您的隐私数据的安全。请在向邮鸽提交个人数据之前，阅读、了解本《隐私政策》（下文简称“本政策”）。本政策适用于邮鸽网络有限公司开发及联合开发的包括但不限于显示本隐私政策、或链接至本隐私政策的所有邮鸽网站和产品、服务。</p>

  <p> 本政策阐述了邮鸽如何搜集、使用及处理您的个人数据，但本政策可能并不涉及所有可能的数据处理情形。有关收集产品或服务特定数据的提示信息可能由邮鸽被不断地、定时地被补充在政策中，或者在收集数据时提供的通知中发布。</p>

  <p> “您”是指所有使用邮鸽产品享受邮鸽提供的服务的自然人及法人组织（包括企业内使用邮鸽产品系统的所有成员），而不单纯限于购买、下载、对接服务的管理人员。</p>

  <p> 请您知悉，您在使用邮鸽产品或服务时，可能需要您根据本政策描述的场景及方式提供您的个人数据。在某些情况下，您可以选择不向邮鸽提供个人数据，但如果您选择不提供，邮鸽可能无法为您提供相关产品或服务，也无法回应或解决您所遇到的问题。</p>

  <p> 请您认真且仔细地阅读本《隐私政策》，并将您是否同意/许可本政策的描述及授权邮鸽按照本政策的描述搜集、使用及处理您的数据，以您是否持续或继续使用邮鸽产品及服务的形式体现。且请您知悉，被授权的主体包含邮鸽网络有限公司及其全球范围内的所有关联公司及其全球关联公司平台产品，如：您的授权将视为您同意在您注册邮鸽通行证后，允许邮鸽及关联平台产品获取及使用您的用户注册信息。</p>

  <p> 我们制定本政策的目的在于帮助您了解以下内容：<br>
    &nbsp;&nbsp;&nbsp;&nbsp;1.我们如何收集和使用您的个人数据<br>
    &nbsp;&nbsp;&nbsp;&nbsp;2.我们如何使用&nbsp;Cookie&nbsp;和同类技术<br>
    &nbsp;&nbsp;&nbsp;&nbsp;3.我们如何披露您的个人数据<br>
    &nbsp;&nbsp;&nbsp;&nbsp;4.我们如何访问或修改您的个人数据<br>
    &nbsp;&nbsp;&nbsp;&nbsp;5.我们如何保护您的个人数据<br>
    &nbsp;&nbsp;&nbsp;&nbsp;6.我们如何处理儿童的个人数据<br>
    &nbsp;&nbsp;&nbsp;&nbsp;7.第三方提供商及其服务<br>
    &nbsp;&nbsp;&nbsp;&nbsp;8.您的个人数据如何在全球范围转移<br>
    &nbsp;&nbsp;&nbsp;&nbsp;9.本政策如何更新<br>
    &nbsp;&nbsp;&nbsp;&nbsp;10.如何联系邮鸽</p>

  <p class="content-titile">一、我们如何收集和使用您的个人数据</p>
  <p> 个人数据是指单独使用或结合其他信息使用时能够识别个人身份的信息。此类数据会在您使用我们的网站、产品或服务，以及与我们互动时由您直接提交给我们，例如，当您创建我们的账户或联系我们获得支持时；或者我们通过记录您如何与我们的网站、产品或服务交互而获得，例如，通过Cookie等技术，或者从您设备上运行的软件接收使用数据。在法律允许的情况下，我们还会从公用和商用第三方来源获取有关数据，例如，我们通过从其他公司购买统计数据来支持我们的服务。我们收集的数据取决于您与邮鸽互动的方式，包括访问的网站或者使用的产品和服务等，包括姓名、性别、企业名称、职位、地址、电子邮箱、电话号码、登录信息（帐号和密码）、照片、证件信息等。我们还收集您提供给我们的信息和您发给我们的消息内容，例如您输入的查询信息或您为了获得客服支持而提供的问题或信息。获取技术支持服务时，可能会需要您提供服务凭证，用于技术支持识别客户信息。服务凭证在数据决策平台—注册管理页面生成，服务凭证内包含公司ID、项目ID、合同ID信息。</p>

  <p>1.如何搜集数据</p>
  <p> 以下，我们将向您展示邮鸽的产品及服务将在哪些场景下及如何搜集您的数据：</p>
  <p>1.1产品注册</p>
  <p>您开始使用邮鸽产品时，注册时所提供的信息将用于创建您的用户账号，包括：您部署完成的系统中某个用户的账号和密码以及您的系统所在的服务器用户的账号和密码。并且在您联系邮鸽用户服务部门时，&nbsp;这些信息还将协助邮鸽为您提供支持，在您的授权下帮助您完成某个特定的功能使用，包括但不限于升级、配置集群、调试、还原、解决某个具体问题，正常使用产品。此外，邮鸽还将使用这些信息来通知您有关您可能感兴趣的任何升级、新产品、促销或其他信息。</p>

  <p> 1.2产品使用</p>
  <p>邮鸽可能将产品使用中收集的信息用于：定期验证您对产品的使用权利；&nbsp;向您发送新产品/新功能升级的通知前，确认您是否正在使用该产品/功能的较早版本或者是否会对您使用邮鸽有所帮助；&nbsp;以及，从邮鸽接收您请求获取的产品内部消息。</p>

  <p> 1.3内部分析</p>
  <p>我们对于这些数据的收集和使用，都是为了向您提供服务且保障服务的正常运行和您所使用帐号的安全、并且帮助发现您在使用邮鸽产品及服务过程中遇到的问题，以提示我们及时对产品功能及服务做出改进和优化，最终给您带来更好的产品和服务体验；以及为您提供更适合您的配置方案建议，促使您可以更便捷地根据您自身的基础条件和个性化需求，更优更充分使用地使用邮鸽产品。</p>
  <p> 包括：</p>
  <div class="content-text3">
  <p> (1)我们会搜集一些用于识别您身份的数据，帮助我们为您提供更准确的服务；<br>
    (2)我们会搜集一些关于您使用邮鸽产品时部署发服务器的环境信息，包括您系统的容量以及版本等；<br>
    (3)我们会搜集一些关于您使用邮鸽产品的工程配置信息；<br>
    (4)我们会搜集一些关于您的操作偏好信息，帮助改善及提升您的使用感受和服务体验。</p>
  </div>
  <p> 1.4问题处理</p>
  <div class="content-text3">
  <p> 为帮助解决您在使用邮鸽产品的过程中出现的不同程度的问题及帮助我们改善产品功能，我们可能出于准确定位问题，需要授权获取您的：</p>
  <p> (1)日志文件，包括但不限于dump文件、log等类型的日志文件；<br>
    (2)工程文件，（其中不包括您数据库中的数据），仅用于尝试还原和分析您系统中遇到的某个隐患问题，并且问题还原和分析完成后，会删除工程文件，不再使用；<br>
    (3)报错界面截图：可能存在需要您主动提供报错界面截图或者在错误发生时，为更快更及时地定位错误发生原因采取的自动截图等的情况，请您知悉，我们仅关注错误原因相关的信息，并且从不会将截图可能覆盖的数据对任何第三方进行披露。</p>
  </div>

  <p>2.搜集数据的目的</p>
  <p>以下，我们可能将您的个人数据用于以下目的：</p>
  <div class="content-text3">
  <p>(1)创建账户。<br>
  (2)实现您的交易或服务请求，包括履行订单；交付、激活或验证产品或服务；提供培训及认证并管理和处理培训及认证结果；参加线上或线下活动；应您的要求进行变更或者提供您请求的信息（例如产品或服务的营销资料、白皮书）；以及提供技术支持。<br>
  (3)&nbsp;在您同意的情况下，与您联系；向您发送有关您可能感兴趣的产品和服务的信息；邀请您参与邮鸽活动（包括促销活动）、市场调查或满意度调查；或向您发送营销信息。如果您不想接收此类信息，则可以随时退订。<br>
  (4)向您发送重要通知，如操作系统或应用程序更新和安装的通知。<br>
  (5)&nbsp;为您提供个性化用户体验和个性化内容。<br>
  (6)&nbsp;认证和管理供应商及业务合作伙伴，与供应商及业务合作伙伴沟通或开展业务。<br>
  (7)&nbsp;开展内部审计、数据分析和研究，改善我们的产品和服务。<br>
  (8)&nbsp;分析业务运营效率并衡量市场份额。<br>
  (9)&nbsp;在您选择向我们发送错误详情的情况下排查错误。<br>
  (10)同步、共享和存储您上传或下载的数据以及执行上传和下载所需的数据。<br>
  (11)&nbsp;保护我们产品、服务和客户或用户的安全，执行与改善我们的防损和反欺诈计划。<br>
  (12)&nbsp;遵从和执行适用的法律要求，相关的行业标准或我们的政策。</p>
</div>

  <p> 3.&nbsp;非识别数据</p>
  <p> 邮鸽还可能收集和使用非识别性数据。非识别性数据是指无法用于确定个人身份的数据。非识别性数据主要包含如下类别：</p>
  <div class="content-text3">
  (1)产品终端（设计器&amp;移动端）的版本信息。<br>
  (2)产品终端（设计器&amp;移动端）功能使用量统计（包含模板制作耗时、alphafine功能记录）。<br>
  (3)产品终端（设计器&amp;移动端）奔溃程序错误日志。<br>
  (4)产品终端（设计器&amp;移动端）连接的服务器基本环境信息（产品版本、环境容器类型、JDK版本等）。<br>
  (5)&nbsp;产品终端（设计器&amp;移动端）连接的服务器的产品功能使用统计（功能使用量、模板使用量等）。<br>
  </div>
  <p> 邮鸽收集此数据的目的在于了解用户如何使用自己的产品和服务。借此，邮鸽可以改善自己的服务，更好地满足客户需求。邮鸽可能会自行决定出于其他目的收集、使用、处理、转移或披露非识别性数据。&nbsp;我们会尽力隔离您的个人数据和非识别性数据，并单独使用这两种数据。如果个人数据掺杂了非识别性数据，依旧会被视作个人数据处理。</p>

  <p>4.&nbsp;数据的合法化处理</p>

  <p> 当邮鸽处理您的个人数据时我们会遵从适用的法律的要求基于适当的合法性基础予以处理，包括：</p>
  <div class="content-text3">
  (1)当响应您的交易或服务请求时为履行合同处理您的个人数据；<br>
  (2)基于您的同意处理您的个人数据；<br>
</div>

  <p>当与您联系、进行营销或市场调查，为改善我们的产品和服务，执行与改善我们的防损和反欺诈计划等目的处理您的个人数据时我们将基于我们或第三方的合法利益。这些合法利益包括，使我们能够更有效的管理和运营我们的业务并提供我们的产品和服务；保护我们的业务、系统、产品、服务和客户的安全；内部管理，遵从内部的政策和流程；我们在本政策中描述的其他合法利益等；<br>
    我们还可能基于遵从和执行法律义务处理您的个人数据。</p>

  <p class="content-titile">二、我们如何使用&nbsp;Cookie&nbsp;和同类技术</p>
  <p> 1.&nbsp;Cookie</p>

  <p> 为确保网站正常运转，我们有时会在计算机或移动设备上存储名为&nbsp;Cookie&nbsp;的小数据文件。Cookie&nbsp;是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie&nbsp;的内容只能由创建它的服务器检索或读取。每个&nbsp;Cookie&nbsp;对您的网络浏览器或移动应用程序都是唯一的。Cookie&nbsp;通常包含标识符、站点名称以及一些号码和字符。借助于&nbsp;Cookie，网站能够存储用户偏好或购物篮内的商品等数据。</p>

  <p> 邮鸽启用Cookie的目的与大多数网站或互联网服务提供商启用&nbsp;Cookie&nbsp;的目的一样，即改善用户体验。借助于&nbsp;Cookie，网站能够记住用户的单次访问（使用会话&nbsp;Cookie）或多次访问（使用永久&nbsp;Cookie）。借助于&nbsp;Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。如果某个网站不使用&nbsp;Cookie，那么在用户每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一个网页，该网站就不会识别出您，而您会被再次注销。&nbsp;邮鸽不会将&nbsp;Cookie&nbsp;用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除&nbsp;Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有&nbsp;Cookie，大部分网络浏览器都设有阻止&nbsp;Cookie&nbsp;的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问以下链接：</p>

  <p>Internet&nbsp;Explorer&nbsp;Google&nbsp;Chrome&nbsp;Mozilla&nbsp;Firefox&nbsp;&nbsp;Safari&nbsp;Opera</p>

  <p> 2.&nbsp;网站信标和像素标签<br>
    除&nbsp;Cookie&nbsp;外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，邮鸽向您发送的电子邮件可能含有链接至邮鸽网站内容的点击&nbsp;URL。如果您点击该链接，邮鸽则会跟踪此次点击，帮助我们了解您的产品和服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从邮鸽的寄信名单中退订。</p>

  <p> 您使用我们的网站意味着您同意按照如上所述使用Cookie，网站信标和像素标签。</p>

  <p class="content-titile">三、我们如何披露您的个人数据</p>
  <p>在某些服务由我们的授权合作伙伴提供的情况下，我们会如本政策描述与该合作伙伴共享您的个人数据。例如，在您上网购买我们产品时，我们必须与物流服务提供商共享您的个人数据才能安排送货，或者安排合作伙伴提供服务。此外，我们可能在我们的关联公司间共享个人数据。</p>

  <p class="content-titile">四、如何访问或修改您的个人数据</p>
  <p> 您应确保提交的所有个人数据都准确无误。我们会尽力维护个人数据的准确和完整，并及时更新这些数据。</p>

  <p> 当适用的法律要求的情况下，您可能(1)有权访问我们持有的关于您的特定的个人数据；(2)要求我们更新或更正您的不准确的个人数据；(3)拒绝或限制我们使用您的个人数据；以及(4)要求我们删除您的个人数据。如果您想行使相关的权利，请在线反馈给我们。为保障安全，您可能需要提供书面请求。如果我们有合理依据认为这些请求存在欺骗性、无法实行或损害他人隐私权，我们则会拒绝处理请求。</p>

  <p> 当适用的法律要求的情况下，当我们基于您的同意处理您的个人数据时，您还有权随时撤销您的同意。但撤销同意不会影响撤销前我们基于您的同意处理您个人数据的合法性及效力，也不影响我们基于其他适当的正当性基础处理您的个人数据。</p>

  <p> 如果您认为我们对您的个人信息的处理不符合适用的数据保护法律，您可以与法定的数据保护机构联系。</p>

  <p class="content-titile">五、我们如何保护和留存您的个人数据</p>
  <p> 我们重视个人数据的安全。我们采用适当的物理、管理和技术保障措施来保护您的个人数据不被未经授权访问、披露、使用、修改、损坏或丢失。例如，我们会使用加密技术确保数据的机密性；我们会使用保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人数据；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人数据重要性的认识。我们会尽力保护您的个人数据，但是请注意任何安全措施都无法做到无懈可击。</p>

  <p> 我们将会在达成本政策所述目的所需的期限内保留您的个人数据，对于超过必要存储期限的数据，我们将采取删除或匿名化处理，除非按照法律要求或许可需要延长保留期。因为基于不同的场景和产品及服务的不同，数据的存储期可能会有所不同，我们用于确定存留期的标准包括：完成该业务目的需要留存个人数据的时间，包括提供产品和服务，维护相应的交易及业务记录，管控并提升产品与服务性能与质量，保证系统、产品和服务的安全，应对可能的用户查询或投诉，问题定位等；用户是否同意更长的留存期间；法律、合同等是否有保留数据的特殊要求等。只要您的账户是为您提供服务必须，我们都将保留您的注册信息。您也可以选择注销您的账号，在您注销账号后，我们会停止基于该账号提供产品和服务，并在无特殊法律要求的情况下，删除您相应的个人数据。</p>

  <p class="content-titile">六、我们如何处理儿童的个人数据</p>
  <p> 我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户帐户。对于经父母同意而收集儿童个人数据的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或披露此数据。&nbsp;如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人数据，则会设法尽快删除相关数据。</p>

  <p class="content-titile">七、第三方提供商及其服务</p>
  <p> 为确保流畅的浏览体验，您可能会收到来自我们及其合作伙伴外部的第三方（下文简称“第三方”）提供的内容或网络链接。我们对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。</p>

  <p> 我们无法控制第三方的隐私和数据保护政策，此类第三方不受到本政策的约束。在向第三方提交个人信息之前，请参见这些第三方的隐私保护政策。</p>

  <p class="content-titile">八、您的个人数据如何在全球范围转移</p>
  <p> 我们是一家跨国公司，这意味着，我们收集的您的个人数据可能会在您使用产品或服务所在国家/地区、在我们或其关联公司、子公司或服务提供商、业务合作伙伴设有机构的其他国家/地区进行处理，或者受到来自这些国家/地区的访问。这些国家/地区的数据保护法可能不同。在此类情况下，我们会采取措施确保我们收集的数据依据本政策和适用法律的要求进行处理。</p>

  <p class="content-titile">九、本政策如何更新</p>
  <p>我们保留不时更新或修改本政策的权利。如果我们的隐私政策变更，我们会将最新版隐私政策发布在这里。如果我们对隐私政策做出了重大变更，我们还可能会通过不同渠道向您发送变更通知，例如，在我们的网站上发布通知或者向您发布单独的通知。</p>

  <p class="content-titile">十、如何联系我们</p>
  <p> 如果您有任何疑问、意见或建议，请通过访问http://www.yoogate.cn与我们联系。</p>

  <p> 当我们按照本隐私政策处理您的个人数据时，响应您的请求、与您联系、向您提供产品或服务或与您达成或即将达成合同的我们实体是相关个人数据的控制者。</p>

  <p>本政策最新修订时间：2024年03月28日</p>
</div>
</template>

<script>
export default {
  name: 'privacyAgreement',
  components: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.agreement-titile {
  font-size: 20px;
  line-height: 40px;
  padding: 15px 40px;
  font-weight: bold;
}

.text-container>p {
  font-size: 16px;
  line-height: 20px;
  padding: 5px 40px;
}

.content-titile {
  font-size: 20px;
  line-height: 30px;
  padding: 15px 40px;
  font-weight: bold;
  text-indent: 0em !important;
}

.content-text3 {
  padding: 15px 40px 15px 50px;
}
</style>
